import React, { useCallback } from 'react'

import useMutateFavorites from 'utils/hooks/queries/games/useMutateFavorites'

import withCondition from '../../../withCondition'
import StyledFavoriteHeart from './styles/StyledFavoriteHeart'

interface Props {
  isFavorite: boolean
  slug: string
}

function FavoriteIcon({ isFavorite, slug }: Props) {
  const { mutate: mutateFavorite } = useMutateFavorites({ slug, isFavorite })
  const onFavoriteChange = useCallback(() => mutateFavorite(), [mutateFavorite])

  const className = isFavorite ? `active-favorite active-favorite-${slug}` : ''

  return (
    <StyledFavoriteHeart
      className={className}
      height={24}
      active={isFavorite}
      onClick={onFavoriteChange}
    />
  )
}

export default withCondition(FavoriteIcon)
